import React from "react";

/**
 * Animated skeleton loader with multiple variants.
 *
 * @param {Object} props
 * @param {'rows'|'cards'|'metrics'} [props.variant='rows'] - Skeleton style variant.
 * @param {number} [props.count=5] - Number of skeleton items to render.
 * @param {string} [props.className] - Extra classes.
 */
export const SkeletonRows = ({
  variant = "rows",
  count = 5,
  className = ""
}) => {
  const items = Array.from({ length: count });

  if (variant === "rows") {
    return (
      <div className={`space-y-3 ${className}`}>
        {items.map((_, i) => (
          <div
            key={i}
            className="h-12 bg-gray-200 rounded-lg animate-pulse"
            aria-hidden="true"
          />
        ))}
      </div>
    );
  }

  if (variant === "cards") {
    return (
      <div className={`grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ${className}`}>
        {items.map((_, i) => (
          <div
            key={i}
            className="h-28 bg-gray-200 rounded-xl animate-pulse"
            aria-hidden="true"
          />
        ))}
      </div>
    );
  }

  if (variant === "metrics") {
    return (
      <div className={`grid gap-3 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 ${className}`}>
        {items.map((_, i) => (
          <div
            key={i}
            className="h-20 bg-gray-200 rounded-xl animate-pulse"
            aria-hidden="true"
          />
        ))}
      </div>
    );
  }

  return null;
};
